import { useMemo, useState } from 'react';

import { AdminRoles } from 'constants/permissions';
import { useDocumentTitle } from 'hooks/document-title';
import { useSupportUserNames } from 'hooks/use-support-user-names';
import AdminPage from 'layouts/AdminPage/AdminPage';

import { List } from 'components/List/List';

import { useGetCheckTypesQuery } from 'api/check-types-api';

import { CheckTypeEdit } from './CheckTypeEdit/CheckTypeEdit';

const AdminCheckTypes = () => {
  useDocumentTitle('Check Types');

  const [selectedCheckType, setSelectedCheckType] = useState();

  const { data: checkTypes, isLoading } = useGetCheckTypesQuery();
  const { supportUsers, getSupportUser } = useSupportUserNames();

  const handleSelectCheckType = checkType => {
    const supportUserName = getSupportUser(checkType.default_support_user_id);
    const updateSupportUser = {
      ...checkType,
      ...(supportUserName && { support_user: supportUserName }),
    };
    setSelectedCheckType(updateSupportUser);
  };

  const sortedCheckTypes = useMemo(
    () => [...(checkTypes || [])].sort((a, b) => a?.title?.localeCompare(b?.title)),
    [checkTypes],
  );

  return (
    <AdminPage loading={isLoading} title="Check Type" allowedRoles={[AdminRoles.SuperAdmin]}>
      <div className="u-padding--large d-flex align-items-start">
        <List
          title="Check Types"
          subtitle="All our products. Click to configure"
          className="u-margin-right--large u-flex-align-self-normal"
          onNew={() => {}}>
          <List.Category title="Types">
            {sortedCheckTypes?.map(checkType => (
              <List.Item
                key={checkType.id}
                title={checkType.title}
                value={checkType}
                onClick={() => handleSelectCheckType(checkType)}
              />
            ))}
          </List.Category>
        </List>
        {selectedCheckType && (
          <CheckTypeEdit
            checkType={selectedCheckType}
            onClose={() => setSelectedCheckType(null)}
            supportUsers={supportUsers}
          />
        )}
      </div>
    </AdminPage>
  );
};

export default AdminCheckTypes;
